<template>
  <div id="modal" class="row">
    <div>
      <p>{{project}}</p>
      <p id="time">{{formattedElapsedTime}}</p>
    </div>
    <div>
      <button @click="start">
        <i class="fas fa-play"></i>
      </button>
      <button @click="stop">
        <i class="fas fa-pause"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "TimerModal",
  data() {
    return {
      user: {},
      project: "Yen Designs",
      elapsedTime: 0,
      timer: undefined,
    };
  },
  computed: {
    formattedElapsedTime() {
      const date = new Date(null);
      date.setSeconds(this.elapsedTime / 1000);
      const utc = date.toUTCString();
      return utc.substr(utc.indexOf(":") - 2, 8);
    },
  },
  methods: {
    start() {
      this.timer = setInterval(() => {
        this.elapsedTime += 1000;
      }, 1000);
    },
    stop() {
      clearInterval(this.timer);
    },
    reset() {
      this.elapsedTime = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
#modal {
  position: absolute;
  bottom: 15px;
  right: 15px;
  border-radius: 3px;
  box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
}

.row {
  display: flex;
  justify-content: space-between;
  align-content: center;
  background: #fff;
  padding: 10px;
  width: 250px;

  div {
    display: flex;
    justify-content: center;
    align-content: center;

    &:first-of-type {
      flex-direction: column;
    }
  }

  p {
    margin: 0;
    text-align: left;
  }

  button {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 1.2rem;
    color: rgb(70, 70, 70);
    outline: none;
    &:first-child {
      margin-right: 10px;
    }

    &:hover {
      color: #000;
    }
  }

  #time {
    font-size: 1.5rem;
    font-weight: 600;
    margin-top: 0px;
  }
}
</style>